import { defineStyleConfig as i } from "@chakra-ui/react";
import { isTouchScreenDevice as e } from "../../theme-helper.js";
import { ThemeColorToken as o, ThemeBorderToken as a, ThemeRadiusToken as d, ThemeFontToken as t, ThemeFontSizeToken as c } from "../theme-tokens.js";
const l = {
  fontFamily: t.SubHeader,
  borderRadius: d.XLarge,
  border: a.XSmall,
  borderColor: "transparent",
  fontWeight: "medium",
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  _disabled: {
    cursor: "not-allowed",
    opacity: 0.48
  },
  _active: {
    color: o.OnAccent,
    background: o.AccentActive
  }
}, u = {
  background: o.Accent,
  color: o.OnAccent,
  _hover: {
    background: e() ? o.Accent : o.AccentHover,
    _disabled: {
      background: o.Accent,
      color: o.OnAccent
    }
  },
  _active: {
    background: o.AccentActive,
    color: o.OnAccent
  }
}, g = {
  background: o.AccentContainer,
  color: o.OnAccentContainer,
  _hover: {
    background: e() ? o.AccentContainer : o.AccentHover,
    color: e() ? o.OnAccentContainer : o.OnAccent,
    _disabled: {
      background: o.AccentContainer,
      color: o.OnAccentContainer
    }
  },
  _active: {
    background: o.AccentActive,
    color: o.OnAccent
  }
}, b = {
  color: o.OnBackground,
  fontWeight: "medium",
  _hover: {
    color: o.OnBackground,
    bg: e() ? "none" : o.AccentHoverAlpha,
    textDecoration: "none"
  },
  _active: {
    bg: o.AccentActiveAlpha,
    color: o.OnBackground
  }
}, s = {
  color: o.OnBackground,
  fontFamily: t.Body,
  borderRadius: 0,
  fontWeight: "normal",
  background: "transparent",
  textDecorationLine: "underline",
  textUnderlineOffset: "3px",
  width: "fit-content",
  border: 0,
  _hover: {
    color: e() ? o.OnBackground : o.AccentHover
  },
  _active: {
    color: o.AccentActive,
    background: "transparent"
  },
  _disabled: {
    textDecoration: "none"
  }
}, A = {
  flex: "1",
  fontWeight: "normal",
  font: t.Body,
  bg: o.AccentContainer,
  color: o.OnAccentContainer,
  borderRadius: "2px",
  _hover: {
    textDecoration: "underline",
    _disabled: {
      textDecoration: "none"
    }
  },
  // [data-active] is the controlled 'isActive'-state of SegmentedControl
  "&[data-active]": {
    fontWeight: "medium",
    bg: o.Surface,
    color: o.OnSurface,
    ":disabled": {
      bg: o.Surface
    },
    ":hover:disabled": {
      bg: o.Surface
    }
  },
  // Native active selctor, seen when button is in pressed state
  _active: {
    bg: o.AccentHoverAlpha,
    color: o.OnAccentContainer
  }
}, v = {
  background: "transparent",
  color: o.OnBackground,
  borderColor: o.OnBackgroundBorder,
  _active: {
    borderColor: "transparent",
    background: o.AccentActiveAlpha,
    color: o.OnBackground,
    _disabled: {
      background: "transparent",
      borderColor: o.OnBackgroundBorder,
      color: o.OnBackground
    }
  },
  "@media(hover: hover)": {
    _hover: {
      borderColor: "transparent",
      color: o.OnBackground,
      background: o.AccentHoverAlpha,
      _disabled: {
        background: "transparent",
        borderColor: o.OnBackgroundBorder,
        color: o.OnBackground
      }
    }
  }
}, r = '&[aria-pressed="true"]', n = '&[aria-pressed="false"]', k = {
  // Base style
  borderRadius: d.Small,
  borderWidth: a.XSmall,
  borderColor: o.OnSurfaceBorder,
  // Pressed state
  [`${r}`]: {
    background: o.Accent,
    color: o.OnAccent
  },
  // Not pressed state
  [`${n}`]: {
    background: o.Surface,
    color: o.OnSurface
  },
  // Hover styles
  "@media(hover: hover)": {
    [`${r}&:hover`]: {
      background: o.AccentHover,
      borderColor: o.AccentHover,
      _disabled: {
        background: o.Accent,
        borderColor: o.Accent
      }
    },
    [`${n}&:hover`]: {
      background: o.AccentHoverAlpha,
      color: o.OnSurface,
      _disabled: {
        background: o.Surface,
        color: o.OnSurface
      }
    }
  },
  // Active styles
  [`${r}:active`]: {
    color: o.OnAccent,
    background: o.AccentActive
  },
  [`${n}:active`]: {
    color: o.OnSurface,
    background: o.AccentActiveAlpha
  },
  // Define general disabled styles last to ensure they are not overridden
  [`${r}:disabled`]: {
    color: o.OnAccent,
    background: o.Accent,
    borderColor: o.Accent
  },
  [`${n}:disabled`]: {
    color: o.OnSurface,
    background: o.Surface
  }
}, f = i({
  baseStyle: l,
  sizes: {
    lg: {
      px: "24px",
      height: "56px",
      minWidth: "56px",
      fontSize: c.Large
    },
    md: {
      px: "16px",
      height: "40px",
      minWidth: "40px",
      fontSize: c.Medium
    },
    sm: {
      px: "8px",
      height: "24px",
      minWidth: "24px",
      fontSize: c.Small
    }
  },
  variants: {
    primary: u,
    secondary: g,
    ghost: b,
    link: s,
    segmentedControl: A,
    tertiary: v,
    toggle: k
  }
});
export {
  f as buttonConfig
};
